// src/merch/supabase.js
//
// MerchMod's own lightweight Supabase client (same project as Tattune,
// but without Tattune's session bridge / Sentry wiring).

import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || "",
  import.meta.env.VITE_SUPABASE_ANON || ""
);

/** Call an edge function and surface its { error } message nicely. */
export async function callFn(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    let msg = error.message || "Request failed";
    try {
      const j = await error.context?.json?.();
      if (j?.error) msg = j.error;
    } catch { /* ignore */ }
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}
